import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ViewRequestRoutingModule } from "./view-request-routing.module";
import { RequestListPageComponent } from "./request-list-page/request-list-page.component";
import { RequestListComponent } from "./request-list/request-list.component";
import { SharedModule } from "../shared/shared.module";
import { BsDatepickerModule, ModalModule, AccordionModule, BsDropdownModule, TooltipModule } from "ngx-bootstrap";
import { ReviewRequestPageComponent } from "./review-request-page/review-request-page.component";
import { ReviewRequestComponent } from "./review-request/review-request.component";
import { CreateExperimentModalComponent } from "./create-experiment-modal/create-experiment-modal.component";
import { ReactiveFormsModule } from "@angular/forms";
import { RequestActionToolbarComponent } from './request-action-toolbar/request-action-toolbar.component';
import { RequestBarcodeComponent } from './request-barcode/request-barcode.component';
import { ApplicationPipesModule } from "../shared/pipes/application-pipes.module";
import { RequestReviewResolver } from "./resolvers/request-review.resolver";
import { RequestBarcodeResolver } from "./resolvers/request-barcode.resolver";
import { RequestAssignmentModalComponent } from "./request-assignment-modal/request-assignment-modal.component";
import { RequestPlanningModalComponent } from "./request-planning-modal/request-planning-modal.component";
import { RequestReviewModalComponent } from "./request-review-modal/request-review-modal.component";
import { RequestActionToolbarButtonComponent } from "./request-action-toolbar/request-action-toolbar-button/request-action-toolbar-button.component";
import { RequestRejectionModalComponent } from "./request-rejection-modal/request-rejection-modal.component";
import { ConfirmationModalComponent } from "../shared/components/confirmation-modal/confirmation-modal.component";
import { UiSwitchModule } from "ngx-ui-switch";
import { FacilitySelectorComponent } from "./request-planning-modal/facility-selector/facility-selector.component";
import { PlanningTreatmentDetailComponent } from "./review-request/planning-treatment-detail/planning-treatment-detail.component";
import { RequestPlanningTreatmentComponent } from './request-planning-modal/request-planning-treatment/request-planning-treatment.component';
import { RequestPlanningTreatmentSprayComponent } from './request-planning-modal/request-planning-treatment-spray/request-planning-treatment-spray.component';
import { SamplingNeedsGridComponent } from "./sampling-needs-grid/sampling-needs-grid.component";
import { RequestReAssignmentModalComponent } from "./request-reassignment-modal/request-reassignment-modal.component";

@NgModule({
  imports: [
    CommonModule,
    ViewRequestRoutingModule,
    SharedModule,
    BsDatepickerModule.forRoot(),
    TableModule,
    CalendarModule,
    FormsModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    ApplicationPipesModule,
    UiSwitchModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    RequestListPageComponent,
    RequestListComponent,
    ReviewRequestPageComponent,
    ReviewRequestComponent,
    RequestPlanningModalComponent,
    RequestAssignmentModalComponent,
    RequestReAssignmentModalComponent,
    CreateExperimentModalComponent,
    RequestActionToolbarComponent, 
    RequestBarcodeComponent,
    RequestReviewModalComponent,
    RequestActionToolbarButtonComponent,
    RequestRejectionModalComponent,
    FacilitySelectorComponent,
    PlanningTreatmentDetailComponent,
    RequestPlanningTreatmentComponent,
    RequestPlanningTreatmentSprayComponent,
    SamplingNeedsGridComponent
  ],
  exports: [
    RequestListPageComponent, 
    ReviewRequestPageComponent
  ],
  entryComponents: [
    RequestPlanningModalComponent, 
    RequestAssignmentModalComponent,
    RequestReAssignmentModalComponent, 
    RequestReviewModalComponent,
    CreateExperimentModalComponent, 
    RequestActionToolbarButtonComponent, 
    RequestRejectionModalComponent,
    ConfirmationModalComponent
  ],
  providers: [
    RequestReviewResolver, 
    RequestBarcodeResolver
  ]
})
export class ViewRequestModule {}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/view-request.module.ts